module.exports = __webpack_public_path__ + "assets/img/page_10.039e65b8.png";